import * as React from 'react'

function SvgFi(props) {
	return (
		<svg viewBox="0 0 1800 1100" width="1em" height="1em" {...props}>
			<path fill="#fff" d="M0 0h1800v1100H0z" />
			<path fill="#003580" d="M0 400h1800v300H0z" />
			<path fill="#003580" d="M500 0h300v1100H500z" />
		</svg>
	)
}

export default SvgFi
